import "./About.module.css";
import CorporateHeader from "@/reusable_sections/Header";
import OurFormulatedStory from "./sections/OurFormulatedStory";
import TheSilkBowlTeam from "./sections/TheSilkBowlTeam";
import OurTechnologyRoadmap from "./sections/OurTechnologyRoadmap";
import GlobalFooter from "@/reusable_sections/Footer";
export default function AboutPage() {
  return <div>
      <CorporateHeader />
      <OurFormulatedStory />
      <TheSilkBowlTeam />
      <OurTechnologyRoadmap />
      <GlobalFooter />
    </div>;
}